module.exports = __webpack_public_path__ + "img/H01061-01.505d5817.jpg";